import React from 'react';
import './Root.css';
import {Translation, withTranslation, WithTranslation} from 'react-i18next';
import {NavLink, Outlet} from "react-router-dom";
import Layout from "./Layout";

const Root = (props: Props) => {
  document.title = props.t("description.title") + " - " + props.t("zavediaev")

  return (
      <Translation>{t =>
          <div>
            <Layout>
              <Outlet/>
            </Layout>
          </div>
      }</Translation>
  )
}

interface Props extends WithTranslation {
}

export default withTranslation()(Root)
